import React from 'react';
import './App.css';
import Laschetism from './Laschetism';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="App-title">
          <h3>Der Laschonator</h3>
          <h4><small>Worthülsen für Kandidaturattrappen</small></h4>
        </div>
      </header>
      <div className="App-body">
        <Laschetism />
      </div>
      <footer className="App-footer">
        Based on&nbsp;<a href="https://www.reddit.com/r/de/comments/mkt3a8/w%C3%BCrfeln_mit_armin_erstelle_deinen_eigenen/">this Post</a>
      </footer>
    </div>
  );
}

export default App;
